import * as z from "zod";

// Zod 4.4+ は jitless が有効な場合、CSP が `unsafe-eval` なしでも `new Function` の事前検査を行わない。
// Next.js の client instrumentation は hydration 前に実行されるため、client component が Zod schema を評価する前に設定しておく。
z.config({ jitless: true });
